var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerRupees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_16630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18Z",
    fill: "#F6E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.333 9.75C25.8306 9.75 26.2499 10.1411 26.25 10.6426C26.25 11.1441 25.8307 11.5361 25.333 11.5361H19.8418C20.3307 12.1269 20.6777 12.8332 20.8301 13.6074H25.333C25.8307 13.6074 26.25 13.9984 26.25 14.5C26.25 15.0016 25.8307 15.3926 25.333 15.3926H20.8301C20.3966 17.5953 18.3941 19.2499 16.001 19.25H12.8965L20.6455 26.7227L20.709 26.791C21.0059 27.1427 20.9849 27.6638 20.6455 27.9912C20.2883 28.3357 19.7127 28.3357 19.3555 27.9912L10.0234 18.9912C9.42756 18.4166 9.86885 17.4639 10.668 17.4639H16.001C17.385 17.4638 18.5466 16.5886 18.9395 15.3926H10.668C10.1703 15.3926 9.75098 15.0016 9.75098 14.5C9.75098 13.9984 10.1703 13.6074 10.668 13.6074H18.9395C18.5466 12.4114 17.385 11.5362 16.001 11.5361H10.668C10.1703 11.5361 9.75098 11.1441 9.75098 10.6426C9.75111 10.1411 10.1704 9.75001 10.668 9.75H25.333Z",
    fill: "#8C18C3",
    stroke: "#8C18C3",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_16630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerRupees);
export default __webpack_public_path__ + "static/media/Container_Rupees.a67fe690033b2e4580dfeaa79025eefa.svg";
export { ForwardRef as ReactComponent };